import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import useLenis from './hooks/useLenis';
import Landing from './pages/Landing';
import Portal from './pages/Portal';
import AuthCallback from './pages/AuthCallback';

function AppRouter() {
  const location = useLocation();
  useLenis();

  // Process OAuth callback FIRST (synchronously during render) to avoid race conditions
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/portal" element={<Portal />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors theme="dark" />
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
